import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	releases: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createVersionButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	releases: {
		id: 'project-versions.releases',
		defaultMessage: 'Releases',
		description: 'Page title for the Releases page',
	},
	createVersionButton: {
		id: 'project-versions.create-version-button',
		defaultMessage: 'Create version',
		description: 'The button that allows users to create a new version',
	},
	successFlagDescription: {
		id: 'project-versions.success-flag-description',
		defaultMessage: '{name} created.',
		description:
			'The description of the flag that is displayed when creating a version is successful.',
	},
	searchMessage: {
		id: 'project-versions.search.message',
		defaultMessage:
			'Typing any character in this field will update the search results below in the table',
		description:
			'Typing any character in this field will update the search results below in the table',
	},
});
export default messages;
